import { JsonPipe } from '@angular/common'
import { Component, ElementRef, ViewChild } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { TranslatePipe } from '@ngx-translate/core'
import { SvgIconComponent } from 'angular-svg-icon'
import {
  DevToolbarComponent,
  DevToolbarFeatureFlagService,
  DevToolbarFlag,
  DevToolbarPermission,
  DevToolbarPermissionsService,
  DevToolbarToolComponent,
} from 'ngx-dev-toolbar'
import { Highlight } from 'ngx-highlightjs'

import { environment } from '../environments/environment'
import { ButtonComponent } from './components/button/button.component'
import { ErrorService } from './services/error.service'

export const featureFlags: DevToolbarFlag[] = [
  {
    name: 'showDebug',
    id: 'showDebug',
    isEnabled: false,
    isForced: false,
  },
]

export const permissions: DevToolbarPermission[] = [
  {
    id: 'can-edit',
    name: 'Can Edit Posts',
    description: 'Allows editing posts',
    isGranted: false,
    isForced: false,
  },
  {
    id: 'can-delete',
    name: 'Can Delete Posts',
    description: 'Allows deleting posts',
    isGranted: false,
    isForced: false,
  },
  {
    id: 'can-manage-users',
    name: 'Can Manage Users',
    description: 'Allows user management',
    isGranted: false,
    isForced: false,
  },
  {
    id: 'is-admin',
    name: 'Admin Access',
    description: 'Full admin access',
    isGranted: false,
    isForced: false,
  },
]

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    ButtonComponent,
    SvgIconComponent,
    TranslatePipe,
    JsonPipe,
    Highlight,
    DevToolbarComponent,
    DevToolbarToolComponent,
  ],
  templateUrl: './app.component.html',
})
export class AppComponent {
  public isProd = environment.production
  @ViewChild('errorDialog')
  private readonly errorDialog!: ElementRef<HTMLDialogElement>

  public constructor(
    public readonly errorService: ErrorService,
    private readonly featureFlagsService: DevToolbarFeatureFlagService,
    private readonly permissionsService: DevToolbarPermissionsService
  ) {
    this.errorService.mySubject.subscribe(() =>
      this.errorDialog.nativeElement.showModal()
    )
    this.permissionsService.setAvailableOptions(permissions)
    this.featureFlagsService.setAvailableOptions(featureFlags)
  }
}
